import React from 'react';

export function Skip({ color = 'var(--color-grayscale-white', size = 12 }: { color?: string; size?: number }) {
  return (
    <svg fill='none' height={size} viewBox={`0 0 ${size} ${size}`} width={size} xmlns='http://www.w3.org/2000/svg'>
      <path
        clipRule='evenodd'
        d='M7.91855 9.3707C7.30499 9.75718 6.57851 9.98077 5.7998 9.98077C3.60129 9.98077 1.81904 8.19852 1.81904 6C1.81904 5.2213 2.04263 4.49482 2.42911 3.88126L7.91855 9.3707ZM9.16979 8.11987L3.67993 2.63001C4.29373 2.24309 5.02063 2.01923 5.7998 2.01923C7.99832 2.01923 9.78057 3.80148 9.78057 6C9.78057 6.77918 9.55671 7.50607 9.16979 8.11987ZM11.5498 6C11.5498 9.17564 8.97544 11.75 5.7998 11.75C2.62417 11.75 0.0498047 9.17564 0.0498047 6C0.0498047 2.82436 2.62417 0.25 5.7998 0.25C8.97544 0.25 11.5498 2.82436 11.5498 6Z'
        fill={color}
        fillRule='evenodd'
      />
    </svg>
  );
}
